// A target answers ONE question: whose number is this. `rough_in` is the job
// sized early, `market` is what the field would bid, `vendor` is what a named
// competitor will bid — and `my_bid` is what WE will bid. `my_bid` is the only
// one with nothing calculated behind it: the user is the sole author, so its
// results carry `my_unit_price` and leave `calculated_unit_price` NULL.
export const FORECAST_CONFIG_TARGET_VALUES = [
  'rough_in',
  'vendor',
  'market',
  'my_bid',
] as const;

export type ForecastConfigTarget =
  (typeof FORECAST_CONFIG_TARGET_VALUES)[number];
